import React, { Component } from 'react'
import Predefine_PoloNackFull_Soccer from '../components/Predefine_PoloNackFull_Soccer/Predefine_PoloNackFull_Soccer'

export class Predefine_PoloNackFull_SoccerPage extends Component {
  render() {
    return (
     <Predefine_PoloNackFull_Soccer/>
    )
  }
}

export default Predefine_PoloNackFull_SoccerPage